import { render, staticRenderFns } from "./Gnb.vue?vue&type=template&id=b58f2ed0&scoped=true&"
import script from "./Gnb.vue?vue&type=script&lang=js&"
export * from "./Gnb.vue?vue&type=script&lang=js&"
import style0 from "./Gnb.vue?vue&type=style&index=0&id=b58f2ed0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b58f2ed0",
  null
  
)

export default component.exports